<div>
  <div style="text-align: center;">
    <br>
      <h3><b>{{data.message}}</b></h3>
    </div>

    <div class="d-flex w-100 justify-content-center">
      <div>
        <label class="efx-label">Lista de Monedas</label>
        <select class="efx-select" [(ngModel)]="monedas" (ngModelChange)="addValue($event)">
          <option value="">Seleccione una Moneda</option>
          @for (acuList of data.list; track acuList) {
            <option [value]="acuList.code" selected="">
              {{ acuList.code + ': ' + acuList.description }}
            </option>
          }
        </select>
      </div>
    </div>

    <div>
      <div class="d-flex w-100 justify-content-center">
        <button class="efx-button-secondary button-secondary" (click)="onNoClick()">{{data.onCancelText === undefined ? 'Cancelar' : data.onSubmitText}}</button>&nbsp;
        <button class="efx-button-primary button-primary" (click)="onSubmit()" cdkFocusInitial
        [disabled]="btnStatus">{{data.onSubmitText === undefined ? 'Seleccionar' : data.onSubmitText}}</button>
      </div>
      <br>
      </div>
    </div>
